// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "Card-module--arrow-up-and-down--17e65";
export var backgroundImage = "Card-module--backgroundImage--f4e13";
export var cardLink = "Card-module--cardLink--6a878";
export var container = "Card-module--container--38d45";
export var horizontalLayout = "Card-module--horizontalLayout--28e70";
export var imageContainer = "Card-module--imageContainer--f7a55";
export var link = "Card-module--link--69449";
export var overlay = "Card-module--overlay--d3f0b";
export var smallerFontSize = "Card-module--smallerFontSize--e5371";
export var squareImage = "Card-module--squareImage--f7ff6";
export var subtitle = "Card-module--subtitle--ca44a";
export var superTitle = "Card-module--superTitle--8a44a";
export var text = "Card-module--text--8f711";
export var textContainer = "Card-module--textContainer--bffc9";
export var title = "Card-module--title--b6bf3";
export var withColoredBackground = "Card-module--withColoredBackground--7ba3a";
export var withImageAsBackground = "Card-module--withImageAsBackground--fa8c2";
export var withMarginBottom = "Card-module--withMarginBottom--ecfe2";
export var withRoundedCorner = "Card-module--withRoundedCorner--1d1a0";
export var withTransparentBackground = "Card-module--withTransparentBackground--437bf";